import { Outlet, useLocation } from "react-router-dom";
import styles from "./styles.module.css";
import CashierImg from "../../../images/cashier_image.png";
import LoginImg from "../../../images/login_page_image.webp";
import LicenceImg from "../../../images/licence_page_image.webp";
import { ROUTES } from "../../../const";
import RouteTracker from "../../../helpers/RouteTracker";

function RootLayout() {
  const location = useLocation();
  const { pathname } = location;

  let displayedImage = CashierImg;

  if (pathname === ROUTES.LOGIN) {
    displayedImage = LoginImg;
  } else if (pathname === ROUTES.LICENCE_SETUP) {
    displayedImage = LicenceImg;
  }

  return (
    <div className={styles.container}>
      <RouteTracker />
      <div className={styles.left}>
        <div className={styles.imageCard}>
          <img src={displayedImage} className={styles.cashierImg} alt="auth_image" />
        </div>
      </div>
      <div className={styles.right}>
        <Outlet />
      </div>
    </div>
  );
}

export default RootLayout;
